
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
import { DomusoApiService } from "../api/DomusoApiService";
import { useEffect } from "react";
import { MockService } from "../api/MockService";
import { useLocalMock } from "../enums/check";
import { addAppReviewData } from "../redux/actions/actionCreators";

export const useAppReviewInformation = () => {

    const dispatch = useDispatch();
    const cognitoUser = useSelector((state: RootState) => state.auth.cognitoUser);
    const userInfo = useSelector((state: RootState) => state.auth.userInfo);
    const logger = useSelector((state: RootState) => state.logger);
    const domusoApiService = useLocalMock
    ? new MockService(cognitoUser, dispatch)
    : new DomusoApiService(cognitoUser, dispatch);
    const username = userInfo?.username;
    
    useEffect(()=>{
       const fetchAppReviewData = async () => {
            const appReviewData = await domusoApiService.getAppReviewData();
            //userRevuew, dateCreated, dateUpdated can be null if user doesn't have provided a review.
            dispatch(addAppReviewData({
                username,
                userReview: appReviewData?.userReview,
                dateCreated: appReviewData?.dateCreated,
                dateUpdated: appReviewData?.dateUpdated, 
                nextRunDays: appReviewData.days
            }));
       }

       fetchAppReviewData().catch((error) => {
        logger.info("Error while fething app review data");
        logger.error(error);
       })
    },[]);
}